import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { CorrectionRequest, CorrectionResponse } from "@api/types";

export const correctionsClient = {
  submit: (body: CorrectionRequest): Promise<CorrectionResponse> =>
    request(() => apiClient.POST("/corrections", { body })),

  poll: (messageUuid: string): Promise<CorrectionResponse> =>
    request(() =>
      apiClient.GET("/corrections/{message_uuid}", {
        params: { path: { message_uuid: messageUuid } },
      }),
    ),
};
